import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
  MainPageComponent,
  InvestingPlanComponent,
  ProvidentFundComponent,
  PrivateFundComponent,
  FundServiceUnitComponent,
  ContactUsComponent,
  FundComponent,
  DownloadFormComponent,
  ComplianceGoodGovernenceComponent,
  ComplianceIndexManagerComponent,
  NewsComponent,
  MarketConditionsComponent
} from './page';

import { NewsDetailComponent } from './page/news-detail/news-detail.component';
import { FundDatailComponent } from './page/fund-datail/fund-datail.component';

import { AnnounceDetailComponent } from './page/announce-detail/announce-detail.component';
import { EartupdateDetailComponent } from './page/eartupdate-detail/eartupdate-detail.component';
import { PromotionDetailComponent } from './page/promotion-detail/promotion-detail.component'

import { PromotionComponent } from './page/promotion/promotion.component'
import { BenefitDetailComponent } from './page/benefit-detail/benefit-detail.component'
import { CalculateStep2Component } from './page/calculate-step2/calculate-step2.component';
import { CalculateResultComponent } from './page/calculate-result/calculate-result.component';
import { CalculateStep3Component } from './page/calculate-step3/calculate-step3.component';
import { FundrecommComponent } from './page/fundrecomm/fundrecomm.component';
import { FundrecommDetailComponent } from './page/fundrecomm-detail/fundrecomm-detail.component';
import { FundCompareComponent } from './page/fund-compare/fund-compare.component';
import { FundCompareResultComponent } from './page/fund-compare-result/fund-compare-result.component';
import { MarketDetailComponent } from './page/market-detail/market-detail.component';

import { GoodgovernenceDetailComponent } from './page/goodgovernence-detail/goodgovernence-detail.component';
import { EthicDetailComponent } from './page/ethic-detail/ethic-detail.component';
import { CorruptionDetailComponent } from './page/corruption-detail/corruption-detail.component';
import { ProductDetailComponent } from './page/product-detail/product-detail.component';

import { ManagerDetailComponent } from './page/manager-detail/manager-detail.component';
import { TransactionDetailComponent } from './page/transaction-detail/transaction-detail.component';
import { GuidelineDetailComponent } from './page/guideline-detail/guideline-detail.component';
import { VoteDetailComponent } from './page/vote-detail/vote-detail.component';
import { HoldingInvestUnitDetailComponent } from './page/holding-invest-unit-detail/holding-invest-unit-detail.component';

import { TestComponent } from './page/test/test.component';
import { NewsletterDetailComponent } from './page/newsletter-detail/newsletter-detail.component';
import { VdoDetailComponent } from './page/vdo-detail/vdo-detail.component';
import { FavoriteComponent } from './page/favorite/favorite.component';

import { FundDetailUsdComponent } from './page/fund-detail-usd/fund-detail-usd.component';
import { AboutUsComponent } from './component/about-us/about-us.component';
import { FaqComponent } from './page/faq/faq.component';
import { CalendarComponent } from './page/calendar/calendar.component';
import { Sitemap2Component } from './page/sitemap/sitemap2.component';

import { JobListComponent } from './page/job-list/job-list.component';
import { JobDetailComponent } from './page/job-detail/job-detail.component';
import { JobApplyComponent } from './page/job-apply/job-apply.component';
import { JobApplyEducationComponent } from './page/job-apply-education/job-apply-education.component';
import { JobApplyFamilyComponent } from './page/job-apply-family/job-apply-family.component';
import { JobApplyExperienceComponent } from './page/job-apply-experience/job-apply-experience.component';

import { SearchComponent } from './component/search/search.component';
import { JobConfirmComponent } from './page/job-confirm/job-confirm.component';

import { LearningDetailComponent } from './page/learning-detail/learning-detail.component';
import { FormatPdfSaveComponent } from './component/format-pdf-save/format-pdf-save.component';
import { CookieConsentService } from './services/cookie.service';
import { PrivacyPolicyComponent } from './page/privace-polilcy/privace-polilcy.component';

import { ClientReportComponent } from './page/client-report/client-report.component';
import { OneamPrivacyNoticeComponent } from './page/oneam-privacy-notice/oneam-privacy-notice.component'

import { AssignedPersonnelDetailComponent } from './page/assigned-personnel-detail/assigned-personnel-detail.component';
import { TaxConsentComponent } from './page/tax-consent/tax-consent.component';
import { OneamIndexLevelComponent } from './page/oneam-index-level/oneam-index-level.component';
import {AssetProfileComponent} from './page/asset-profile/asset-profile.component';
const routes: Routes = [
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
    canActivate: [CookieConsentService]
  },
  { path: 'test', component: TestComponent, canActivate: [CookieConsentService] },
  { path: 'home', component: MainPageComponent, canActivate: [CookieConsentService] },
  { path: 'fund', component: FundComponent, canActivate: [CookieConsentService] },
  { path: 'calculate', component: InvestingPlanComponent, canActivate: [CookieConsentService] },
  { path: 'calculate/step2', component: CalculateStep2Component, canActivate: [CookieConsentService] },
  { path: 'calculate/step3', component: CalculateStep3Component, canActivate: [CookieConsentService] },
  { path: 'SearchInfo/:search', component: SearchComponent, canActivate: [CookieConsentService] },
  { path: 'calculate/result', component: CalculateResultComponent, canActivate: [CookieConsentService] },
  { path: 'provident-fund', component: ProvidentFundComponent, canActivate: [CookieConsentService] },
  { path: 'private-fund', component: PrivateFundComponent, canActivate: [CookieConsentService] },
  { path: 'fund-service-unit', component: FundServiceUnitComponent, canActivate: [CookieConsentService] },
  { path: 'contact-us', component: ContactUsComponent, canActivate: [CookieConsentService] },
  { path: 'download-form', component: DownloadFormComponent, canActivate: [CookieConsentService] },
  { path: 'th/:choice', component: NewsComponent, canActivate: [CookieConsentService] },
  { path: 'th/Annoucement', component: NewsComponent, canActivate: [CookieConsentService] },
  { path: 'th/EarthUpdate', component: NewsComponent, canActivate: [CookieConsentService] },
  { path: 'Promotion/:type', component: PromotionComponent, canActivate: [CookieConsentService] },
  { path: 'FundRecommend/:type', component: FundrecommComponent, canActivate: [CookieConsentService] },
  { path: 'Favorite', component: FavoriteComponent, canActivate: [CookieConsentService] },
  { path: 'Sitemap2', component: Sitemap2Component, canActivate: [CookieConsentService] },
  { path: 'Faq', component: FaqComponent, canActivate: [CookieConsentService] },
  { path: 'Calendar', component: CalendarComponent, canActivate: [CookieConsentService] },
  { path: 'job-list', component: JobListComponent, canActivate: [CookieConsentService] },
  { path: 'job-detail', component: JobDetailComponent, canActivate: [CookieConsentService] },
  { path: 'job-apply', component: JobApplyComponent, canActivate: [CookieConsentService] },
  { path: 'job-apply-education', component: JobApplyEducationComponent, canActivate: [CookieConsentService] },
  { path: 'job-apply-family', component: JobApplyFamilyComponent, canActivate: [CookieConsentService] },
  { path: 'job-apply-Experience', component: JobApplyExperienceComponent, canActivate: [CookieConsentService] },
  { path: 'job-confirm', component: JobConfirmComponent, canActivate: [CookieConsentService] },
  { path: 'th/News/detail/:id', component: NewsDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/Announce/detail/:id', component: AnnounceDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/EartUpdate/detail/:id', component: EartupdateDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/Promotion/detail/:id', component: PromotionDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/Benefit/detail/:id', component: BenefitDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/fundrecomm/detail/:id', component: FundrecommDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/market/detail/:id', component: MarketDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/newsletter/detail/:id', component: NewsletterDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/vdo/detail/:id', component: VdoDetailComponent, canActivate: [CookieConsentService] },
  { path: 'fund/detail/:id/:currency', component: FundDatailComponent, canActivate: [CookieConsentService] },
  { path: 'en/fund/detail/:id/:currency', component: FundDetailUsdComponent, canActivate: [CookieConsentService] },
  { path: 'fund/compare', component: FundCompareComponent, canActivate: [CookieConsentService] },
  { path: 'fund/compare/result/:fundId1/:fundId2', component: FundCompareResultComponent, canActivate: [CookieConsentService] },
  { path: 'market-conditions', component: MarketConditionsComponent, canActivate: [CookieConsentService] },
  {
    path: 'compliance-good-governence/:type',
    component: ComplianceGoodGovernenceComponent
    , canActivate: [CookieConsentService]
  },
  {
    path: 'compliance-index-manager/:type',
    component: ComplianceIndexManagerComponent
    , canActivate: [CookieConsentService]
  },
  { path: 'th/goodgover/detail/:id', component: GoodgovernenceDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/ethic/detail/:id', component: EthicDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/corruption/detail/:id', component: CorruptionDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/product/detail/:id', component: ProductDetailComponent, canActivate: [CookieConsentService] },

  { path: 'th/manager/detail/:id', component: ManagerDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/transaction/detail/:id', component: TransactionDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/guideline/detail/:id', component: GuidelineDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/vote/detail/:id', component: VoteDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/holding/detail/:id', component: HoldingInvestUnitDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/assigned/detail/:id', component: AssignedPersonnelDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/vdo/detail/:id', component: VdoDetailComponent, canActivate: [CookieConsentService] },
  { path: 'th/newsletter/detail/:id', component: NewsletterDetailComponent, canActivate: [CookieConsentService] },
  { path: 'about-us', component: AboutUsComponent, canActivate: [CookieConsentService] },
  { path: 'th/Learning/detail/:id', component: LearningDetailComponent, canActivate: [CookieConsentService] },
  { path: 'save-pdf/:id/:date', component: FormatPdfSaveComponent, canActivate: [CookieConsentService] },
  { path: 'privacy-notice', component: PrivacyPolicyComponent, canActivate: [CookieConsentService] },
  { path: 'client-report/:id', component: ClientReportComponent, canActivate: [CookieConsentService] },
  { path: 'tax-consent', component: TaxConsentComponent, canActivate: [CookieConsentService] },
  { path: 'index-level/:id', component: OneamIndexLevelComponent, canActivate: [CookieConsentService] },
  { path: 'asset-profile', component: AssetProfileComponent, canActivate: [CookieConsentService] },

  { path: 'oneam-privacy-notice', component: OneamPrivacyNoticeComponent, canActivate: [CookieConsentService] },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
